module.exports = __webpack_public_path__ + "static/media/1.d054447e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Malaysian-Urticaria-Expert-Group/1.jpg
// module id = 662
// module chunks = 0